import {Component, Input} from "@angular/core";
import {BreakDown} from "../../../api/entity/identity-verification";

@Component({
    selector: 'tfl-bo-onfido-verification-report-breakdown',
    template: `
        <div class="col-xs-12" *ngIf="!inner">
            <div class="row">
                <ng-container *ngFor="let key of breakdown | keys; index as i">
                    <div class="col-xs-12 col-sm-6 col-lg-3">
                        <i *ngIf="breakdown[key].result == 'clear'"
                            class="fa fa-check-circle fa-lg text-success"></i>
                        
                        <i *ngIf="breakdown[key].result != 'clear'"
                           class="fa fa-minus-circle fa-lg text-warning"></i>
                        
                        <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.' + getTranslateFieldSuffixByBreakdownKey(key) | translate }}</b>
                        
                        <ng-container *ngIf="breakdown[key].breakdown">
                            <tfl-bo-onfido-verification-report-breakdown [breakdown]="breakdown[key].breakdown" [inner]="true">
                            </tfl-bo-onfido-verification-report-breakdown>
                        </ng-container>
                    </div>
                    <div *ngIf="(i + 1) % 4 == 0" class="clearfix visible-lg-block"></div>
                </ng-container>
            </div>
        </div>
        <ul *ngIf="inner" class="report-breakdown-inner-list">
            <li *ngFor="let key of breakdown | keys">
                <small>
                    <i *ngIf="breakdown[key].result == 'clear'"
                       class="fa fa-check-circle text-success"></i>
                    
                    <i *ngIf="breakdown[key].result != 'clear'"
                       class="fa fa-minus-circle text-warning"></i>

                    {{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.' + getTranslateFieldSuffixByBreakdownKey(key) | translate }}
                </small>
            </li>
        </ul>
    `
})
export class BreakdownReportOnfidoVerificationComponent {

    @Input() breakdown: BreakDown;
    @Input() inner: boolean = false;

    getTranslateFieldSuffixByBreakdownKey(key: string): string {
        return key.toUpperCase();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/results/breakdown.report.onfido.verification.component.ts